import React from "react";
import { CURRENCY_SYMBOL } from "../../../constant";
import { filterNumberColor, filterSign } from "../../../utils/formatNumber";
import LoadingIcon from "../../../components/Loading/LoadingIcon";
import { useTranslation } from "react-i18next";

const Record = ({ gameName, jackpotWin, bet, winLose, index }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`betRecord.${key}`);
  return (
    <div
      className={`bg-base-light-white dark:bg-base-light-dark rounded-[5px] py-common-padding-y px-common-padding-x`}
    >
      <p className="text-transaction-text dark:text-base-light-white text-lg font-semibold mb-[7px] flex items-center">
        {gameName}{" "}
      </p>
      <div className="flex justify-between">
        <div className="flex flex-col text-light-text">
          <p className="text-xs mb-[5px]">{i18n("Bet")}</p>
          <p className="font-bold text-light-text">
            {CURRENCY_SYMBOL} {bet}
          </p>
        </div>

        <div className="flex flex-col text-light-text">
          <p className="text-xs mb-[5px]">{i18n("Win/Lose")}</p>
          <p className={`font-bold ${filterNumberColor(winLose)}`}>
            {CURRENCY_SYMBOL} {winLose}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Record;
